<div class="d-flex justify-content-end">
    <button class="btn" mat-icon-button [disabled]="processLoading" (click)="closeDialog()" type="button">
        <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
</div>

<div class="dcp">
    <!-- Loader -->
    <div *ngIf="progress_spinner" class="w-100 h-100 d-flex align-items-center justify-content-center loader">
        <span class="purpleLoader"></span>
    </div>

    <!-- No Data -->
    <ng-container *ngIf="!progress_spinner">
        <ng-container *ngIf="verifiedItems.length > 0; else noDataTemplate">
            <table class="table ordertable" aria-describedby="Drug list table">
                <thead>
                    <tr>
                        <th>Medication Name</th>
                        <th>Requested Qty</th>
                        <th>Remaining Qty</th>
                        <th>Last Refill Date</th>
                        <th>Rx ID</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of verifiedItems">
                        <td>{{item?.renew_refill_detail?.DrgName || item?.drug_names || 'N/A'}}</td>

                        <td>
                            <ng-container
                                *ngIf="item?.renew_refill_detail?.RxDetail?.DispQty < item?.renew_refill_detail?.RxDetail?.RemQty; else showDispQty">
                                {{ item?.renew_refill_detail?.RxDetail?.RemQty ?
                                (item?.renew_refill_detail?.RxDetail?.DispQty | number:'1.0-0') : 'N/A' }}
                            </ng-container>
                            <ng-template #showDispQty>
                                {{ item?.renew_refill_detail?.RxDetail?.DispQty ?
                                (item?.renew_refill_detail?.RxDetail?.RemQty | number:'1.0-0') : 'N/A' }}
                            </ng-template>
                        </td>
                        <td>{{ (item?.renew_refill_detail?.RxDetail?.RemQty | number:'1.0-0')|| 'N/A'}}</td>
                        <td>{{item?.renew_refill_detail?.RxDetail?.LastFillDate ?
                            helperService.getDate(item?.renew_refill_detail?.RxDetail?.LastFillDate+' UTC') : 'N/A'}}
                        </td>
                        <td>{{item?.added_rx_num}}</td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex justify-content-end gap-2">
                <button class="btn btn-outline-primary" (click)="closeDialog()">Cancel</button>
                <button class="btn btn-primary" [disabled]="processLoading"
                    (click)="openConfirmProcess('partial')">{{processLoading ? 'Confirming...' : 'Partially Confirmed'}}</button>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #noDataTemplate>
        <div class="text-center p-4">
            <p class="mb-0" style="font-size: 20px; font-weight: 500;">Please add at least one Rx to proceed.</p>
        </div>
    </ng-template>
</div>